export default 
{
  "id": "phones",
  "title": "Cell Phones Destroying Society?",
  "videoId": "j_PU9ijjG5U",
  "topic": "Cell Phones",
  "level": "B2",
  "vocabulary": [
  "consider - think about",
  "wreck - ruin",
  "inappropriate suitors - bad guys",
  "distinguish - see the difference between",
  "sin tax - a tax on things people like but that are not good for them like alcohol and cigarettes",
  "I was hard-pressed - It was difficult for me"
],
  "transcript": [
 
      "<h1>Are Cell Phones Really That Bad?</h1>",
"<h2>A Common Debate</h2>",
"<p>Hello subscribers and others, it's David. In this clip, I want to talk about something that constantly comes up in the comments on my YouTube channel.</p>",
"<p>Cell phones—people say they’re horrible for kids, that they’ve destroyed society. They argue we no longer have family dinners, we’ve lost the ability to have real conversations, and our children are addicted to their screens.</p>",
"<h2>The Perspective of a New Generation</h2>",
"<p>I have sons—they're addicted to their phones. They have friends online that they've never met. Is that really a friend? In my generation, a friend was someone you met in person, shook hands with. But to their generation, online friendships are just as real.</p>",
"<h2>The Novel: A Historical Parallel</h2>",
"<p>Now, I want you to consider another form of media—one that once caused just as much panic: the novel.</p>",
"<p>Back in 1740, the novel *Pamela* came out in a smaller size, one that you could carry in your pocket. This new idea of a portable book freaked out governments and critics. They feared it would end thinking, that people wouldn’t be able to distinguish fact from fiction anymore.</p>",
"<p>They argued *Pamela* was particularly dangerous for women, claiming it would cause changes in how they thought, how they saw the world, and that it would distract them from more useful activities. It was said to fill their heads with unrealistic fantasies and make them more likely to run off with inappropriate suitors.</p>",
"<p>The controversy grew, and in 1770, Goethe published a novel that ended with a suicide. People feared copycat deaths, and several governments banned the book and the idea of the novel altogether. By 1778, governments had begun suggesting a sin tax on novels, which would discourage people from reading these harmful books and also provide the government with some extra revenue. It sounds a bit like the marijuana laws or even cell phone laws we may see in the future.</p>",
"<p>People were encouraged by governments to read *true* history books instead of novels, which they claimed were not true.</p>",
"<h2>Personal Reflection on 'Addiction'</h2>",
"<p>I was thinking about my own youth, when we had a kid in my class who played the violin for eight hours a day. He’d play after school, all weekend long. His parents thought it was wonderful. The school thought it was wonderful. It was seen as a perfectly healthy activity. Meanwhile, what we were doing—watching TV—was considered disgusting, horrible, and likely to wreck us. The violin was good, but watching TV was bad.</p>",
"<p>Now, parents are telling kids to read novels. How I feel about it is that the cell phone is neither good nor bad. It simply is. I think young people will be different as a result of it. I was listening to a Stanford lecture last week in which the lecturer said we’ll soon have contact lenses that provide additional information about everything we see.</p>",
"<p>I asked my son, 'If you were out walking in the woods and you saw a tree, versus if you were walking in the woods and saw a tree with all this information popping up—how old it is, who was there before, some photos—what would you prefer?' He’s 18, and he said, 'Of course, the information. Who wouldn’t want that?' I was hard-pressed to argue with him.</p>",
"<p>But then I said, 'What about just being with nature?' And he said, 'I’d rather have the information and be in this three-dimensional space than just be with nature.'</p>",
"<p>I know what some of you will say about this, but I’m suggesting to you that technologies like these shake us up and change things—just like the novel did. But not necessarily in bad ways, in the way we first think.</p>",
"<p>What do you think? I welcome your comments.</p>"


    
],
"questions": [
  {
    "number": "1",
    "question": "Do you think online friendships are as real as in-person friendships?",
    "choices": [
      "A. Yes, they can be just as meaningful.",
      "B. No, you need to meet someone in person for it to count.",
      "C. It depends on the context and the people involved.",
      "D. I am unsure."
    ]
  },
  {
    "number": "2",
    "question": "How do you feel about the comparison between novels in the 1700s and cell phones today?",
    "choices": [
      "A. It's a valid comparison—new media often cause panic.",
      "B. It's not accurate—novels and phones are too different.",
      "C. The comparison is interesting, but a bit exaggerated.",
      "D. I hadn’t thought about it before, so I’m not sure."
    ]
  },
  {
    "number": "3",
    "question": "Should governments play a role in regulating the use of smartphones?",
    "choices": [
      "A. Yes, especially for children and teens.",
      "B. No, it should be a personal or family choice.",
      "C. Maybe, but only in public or professional settings.",
      "D. I’m not sure what the best approach is."
    ]
  },
  {
    "number": "4",
    "question": "Is calling smartphone use an 'addiction' fair or misleading?",
    "choices": [
      "A. It's fair—it has all the signs of addiction.",
      "B. It’s misleading—it’s just a modern habit.",
      "C. It depends on how much and how it’s used.",
      "D. I don’t know enough to say."
    ]
  },
  {
    "number": "5",
    "question": "What’s your opinion on the son’s preference for information about nature instead of just experiencing it?",
    "choices": [
      "A. I agree—more information enhances the experience.",
      "B. I disagree—it ruins the feeling of being present.",
      "C. I see both sides and think balance is important.",
      "D. I’m not sure how I feel about it."
    ]
  },
  {
    "number": "6",
    "question": "Do you agree with the speaker’s idea that technology is not inherently good or bad?",
    "choices": [
      "A. Yes, it’s how we use it that matters.",
      "B. No, some technology is clearly harmful.",
      "C. It depends on the context and long-term effects.",
      "D. I haven’t thought much about it."
    ]
  },
  {
    "number": "7",
    "question": "Do you think future tech like augmented contact lenses will improve our lives?",
    "choices": [
      "A. Yes, it will make daily life more efficient and interesting.",
      "B. No, it will disconnect us even more from the real world.",
      "C. It could help, but there are ethical concerns.",
      "D. I have no strong opinion on this yet."
    ]
  }
]
  }

  
